import { render, staticRenderFns } from "./SoftwareComponentTechnicalAdd.vue?vue&type=template&id=1c586fa4&"
import script from "./SoftwareComponentTechnicalAdd.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentTechnicalAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports